

<div class="orders-container">
  <mat-toolbar>
    <mat-toolbar-row>
      <h2>Orders</h2>
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="orders-split">
  <section class="search-results" style="background-color: #424242;">

    <div class="loading-shade" *ngIf="resultsLoading">
      <mat-spinner></mat-spinner>
    </div>
    <div #tableContainer class="table-container">

      <table #ordersTable mat-table [dataSource]="sortedData" matSort (matSortChange)="sortData($event)">
        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->
      
        <!-- Position Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> ID 

          </th>
          <td mat-cell *matCellDef="let element">{{element.order_id}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
      
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element"><a [routerLink]="'/orders/' + element.order_id">{{element.zedder && element.zedder.firstname}} {{element.zedder && element.zedder.lastname}}</a></td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="invoice">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Invoice </th>
          <td mat-cell *matCellDef="let element">{{element.invoice_no}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
      
        <ng-container matColumnDef="email">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let element">{{element.zedder && element.zedder.email}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
      
        <ng-container matColumnDef="phone">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Phone </th>
          <td mat-cell *matCellDef="let element">{{element.zedder && element.zedder.phone}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="items">
          <th mat-header-cell *matHeaderCellDef> Items </th>
          <td mat-cell *matCellDef="let element">{{element.items_json && element.items_json.length}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="merch">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Merch </th>
          <td mat-cell *matCellDef="let element">{{element.hasMerch}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
      
        <ng-container matColumnDef="total">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Total </th>
          <td mat-cell *matCellDef="let element">{{element.total}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
      
        <ng-container matColumnDef="transaction">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Method </th>
          <td mat-cell *matCellDef="let element">{{element.transaction.length && element.transaction[0].service}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="payer">
          <th mat-header-cell *matHeaderCellDef> Payer </th>
          <td mat-cell *matCellDef="let element">{{element.transaction.length && element.transaction[0].payer_id}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="transtatus">
          <th mat-header-cell *matHeaderCellDef> Transaction Status </th>
          <td mat-cell *matCellDef="let element">{{element.transaction.length && element.transaction[0].capture_status}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="processed">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element">{{element.processed}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Created </th>
          <td mat-cell *matCellDef="let element">{{element.created_at | date:'dd/MM/yy hh:mm a'}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="updated">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Updated </th>
          <td mat-cell *matCellDef="let element">{{element.updated_at | date:'dd/MM/yy hh:mm a'}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="id-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
            <mat-form-field subscriptSizing="dynamic" style="width: 70px; min-width: 100%;">
              <mat-label>ID</mat-label>
              <input #input matInput (keyup)="applyFilter($event, 'id')">
            </mat-form-field>
          </th>
        </ng-container>

        <ng-container matColumnDef="name-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
            <mat-form-field subscriptSizing="dynamic" style="width: 70px; min-width: 100%;">
              <mat-label>Name</mat-label>
              <input #input matInput (keyup)="applyFilter($event, 'name')">
            </mat-form-field>
          </th>
        </ng-container>

        <ng-container matColumnDef="invoice-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
          </th>
        </ng-container>
            
        <ng-container matColumnDef="email-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
            <mat-form-field subscriptSizing="dynamic" style="width: 70px; min-width: 100%;">
              <mat-label>Email</mat-label>
              <input #input matInput (keyup)="applyFilter($event, 'email')">
            </mat-form-field>
          </th>
        </ng-container>    

        <ng-container matColumnDef="phone-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
            <mat-form-field subscriptSizing="dynamic" style="width: 70px; min-width: 100%;">
              <mat-label>Phone</mat-label>
              <input #input matInput (keyup)="applyFilter($event, 'phone')">
            </mat-form-field>
          </th>
        </ng-container>

        <ng-container matColumnDef="items-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
          </th>
        </ng-container>

        <ng-container matColumnDef="merch-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
            <mat-form-field subscriptSizing="dynamic" style="width: 70px; min-width: 100%;">
              <mat-label>Merch</mat-label>
              <mat-select (selectionChange)="applyFilter($event, 'merch')" matNativeControl>
                <mat-option value=""></mat-option>
                <mat-option value="true">Merch</mat-option>
                <mat-option value="false">No-merch</mat-option>
              </mat-select>
            </mat-form-field>
          </th>
        </ng-container>

        <ng-container matColumnDef="total-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
          </th>
        </ng-container>

        <ng-container matColumnDef="transaction-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
          </th>
        </ng-container>

        <ng-container matColumnDef="payer-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
          </th>
        </ng-container>

        <ng-container matColumnDef="transtatus-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
          </th>
        </ng-container>

        <ng-container matColumnDef="processed-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
            <mat-form-field subscriptSizing="dynamic" style="width: 70px; min-width: 100%;">
              <mat-label>Status</mat-label>
              <mat-select (selectionChange)="applyFilter($event, 'processed')" matNativeControl>
                <mat-option value=""></mat-option>
                <mat-option value="processing">processing</mat-option>
                <mat-option value="unprocessed">unprocessed</mat-option>
                <mat-option value="fix">fix</mat-option>
                <mat-option value="checked">checked</mat-option>
                <mat-option value="completed">completed</mat-option>
                <mat-option value="ready">ready</mat-option>
              </mat-select>
            </mat-form-field>
          </th>
        </ng-container>

        <ng-container matColumnDef="created-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
          </th>
        </ng-container>

        <ng-container matColumnDef="updated-filter">
          <th mat-header-cell *matHeaderCellDef style="padding: 0;">
          </th>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-header-row *matHeaderRowDef="displayedFilters; sticky: false"></tr>
        <tr mat-row (click)="clickedRows(row)" [class.selected-row]="searchResultsSelection === row" *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>    
    </div>
    <div style="display: flex; align-items: center;">
      <button (click)="fetchOrders()" mat-icon-button matTooltip="Refresh" matTooltipPosition="above" style="margin-left: 8px; color: #a8a8a8;">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Columns" matTooltipPosition="above" style="margin-left: 8px; color: #a8a8a8;">
        <mat-icon>view_column</mat-icon>
      </button>
      <mat-menu #menu="matMenu" > 
        <div style="max-height: 300px; min-width: 150px; overflow-y: scroll;">
          <div *ngFor="let col of allColumns; index as c">
            <mat-checkbox [checked]="col.visible" (change)="changeColumns(c, $event)">
              {{col.column}}
            </mat-checkbox>
          </div>
        </div>
      </mat-menu>
      <mat-paginator style="flex: 1" #ordersPaginator [length]="resultsLength" [pageSize]="40" [pageSizeOptions]="[40, 80, 120, 240]"
      showFirstLastButtons
      aria-label="Select page of orders">
    </mat-paginator>
    </div>


  </section>

  <section class="order-details">
    <!-- <ui-view></ui-view> -->
    <router-outlet></router-outlet>
  </section>
  </div>
</div>